module.exports = __webpack_public_path__ + "static/img/hcp-seg-brintellix-2.12acdb03.png";